import APIMapper from './APIMapper';
import TriggerController from "../../controllers/TriggerController";

class TriggerAPIMapper extends APIMapper {
  update(change) {
    const { item, onSuccess, onError } = change;
    return TriggerController.putTrigger(item.nextValue)
      .then(onSuccess)
      .catch(onError);
  }

  delete(change) {
    const { item, onSuccess, onError } = change;

    return TriggerController.deleteTrigger(item.prevValue.id)
      .then(onSuccess)
      .catch(onError);
  }
}

export default new TriggerAPIMapper();
